import { DimensionContext } from "@contexts/Dimension"
import { MainCardProps } from "@table/MainCard"
import React, { useContext } from "react"
import { cardColorArray, CardDataClass, cardTypeArray } from "@uno/common"

export interface CardProps {
  card: CardDataClass
  chosenColor?: MainCardProps["chosenColor"]
  type: "inFan" | "main"
  disabled?: boolean
}

const fullWidth = 3910
const fullHeight = 1380

const maxHeight = 180
const maxWidth = 120

export const cardWidth = 230
export const cardHeight = 345

export default function Card({
  card: { cardColor, cardType, custom },
  chosenColor,
  type,
  disabled = false,
}: CardProps) {
  const { cardScale } = useContext(DimensionContext)

  const baseScale = cardScale * (type === "main" ? 0.5 : 0.7)
  const heightBasedScale = maxHeight / cardHeight
  const widthBasedScale = maxWidth / cardWidth

  const scale = Math.min(baseScale, heightBasedScale, widthBasedScale)

  const typeIndex = cardTypeArray.indexOf(cardType) + (chosenColor ? 2 : 0)
  const colorIndex = cardColorArray.indexOf(chosenColor ?? cardColor)

  const xPos = -typeIndex * cardWidth
  const yPos = -colorIndex * cardHeight

  return (
    <div
      style={{
        backgroundImage: `url(/assets/customs/cards/deck/${custom || "default.svg"})`,
        backgroundOrigin: "border-box",
        backgroundPosition: `${xPos * scale}px ${yPos * scale}px`,
        backgroundSize: `${fullWidth * scale}px ${fullHeight * scale}px`,
        height: `${cardHeight * scale}px`,
        width: `${cardWidth * scale}px`,
        filter: disabled ? "brightness(0.5)" : "none",
      }}
      className="z-20"
    />
  )
}
